

<template>
    <el-container class="workspace">
        <el-menu class="el-menu-vertical-demo noprint" background-color="#001529" text-color="#efefef" :collapse="isCollapse" unique-opened="true" style="overflow-y:auto;overflow-x:hidden">
            <el-menu-item index="1">
                <span></span>
                <span slot="title">鹏龙天创MRO</span>
            </el-menu-item>
            <el-submenu v-for="(menu, index) in menus" :index="index+''" :key="index">
                <template slot="title">
                <i :class="menu.icon"></i>
                <span slot="title">{{ menu.name }}</span>
                </template>
                <el-menu-item v-for="(submenu, subindex) in menu.children" @click='nav(submenu.uri)' :index="index + '-' + subindex+''" :key="index + '-' + subindex">{{ submenu.name }}</el-menu-item>
            </el-submenu>
        </el-menu>
        <el-container>
            <el-header class="noprint">
                <span class="toggle" @click="toggleMenu"><i v-bind:class="{ 'el-icon-s-fold' : !isCollapse, 'el-icon-s-unfold' : isCollapse}"></i></span>
                <div class="bread">
                    <el-breadcrumb separator="/" class="breadcrumb">
                        <el-breadcrumb-item  :to="{ name: v.path }" v-for="v in lists" :key="v.path" >{{v.title}}</el-breadcrumb-item>
                        <el-link v-if="isReturn" class="el-breadcrumb__inner is-link"  @click="() => {goBack();}">返回</el-link>
                    </el-breadcrumb>
                </div>
                <div class="ops">
                    <span v-if="companies.length === 0" style="margin-right: 20px;">{{ company }}</span>
                    <el-dropdown v-if="companies.length > 0" style="margin-right: 20px;" @command="changeCompany">
                        <span class="el-dropdown-link">
                            {{ company }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="c in companies" :key="c" :command="c">{{ c }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                    <span style="margin-left:5px;font-size:14px">{{ name }}</span>
                    <el-link type="primary"  style="margin-left:20px" @click="logout">退出</el-link>
                </div>
            </el-header>
            <el-main>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"/>
            </el-main>
            <div class="noprint" style="text-align: center;padding-bottom:3px;">©2023 北京鹏龙天创物资贸易有限公司</div>
        </el-container>
    </el-container>
</template>
<script>
export default {
    name: 'workspace',
    data() {
        return {
            isReturn:false,
            lists:[],
            isCollapse: false,
            menus: [],
            name: "",
            company: '',
            companies: [],
        }
    },
    mounted(){
        this.$bus.$on('menuClose',(data)=>{
           if(!this.isCollapse){
               this.isCollapse = data;
           }
        })
    },
    watch: {
        '$route': function(to, from) {
            this.getBreadcrumb(to.matched,from.matched,to.params);
        }
    },
    methods: {
        toggleMenu() {
            this.isCollapse = !this.isCollapse;
        },
        nav(path) {
            // this.$router.getRoutes().find(e=> e.name == "jcyorder").meta.keepAlive = false;
            this.$router.push({name: path});
        },
        logout() {
            this.$store.commit("logout");
            this.$router.push("/");
        },
        goBack() {
            this.$router.go(-1);
        },
        getCompanies() {
            const that = this;
            this.$axios.get("/admin/user/loginUserCompanies")
            .then(response=>{
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.company = resp.data[0];
                    if(resp.data.length > 1) {
                        that.companies = resp.data.slice(1);
                    }
                }
            });
        },
        changeCompany(company) {
            this.$axios.get(`/admin/user/changeCompany/${company}`)
            .then(response=>{
                let resp = response.data;
                if(resp.header.status == 0) {
                    location.href="/workspace";
                }
            });
        },
        getBreadcrumb(matched,from,params) {
            // console.log(JSON.stringify(matched));// eslint-disable-line
            // alert(JSON.stringify(matched).toString());
            //alert(matched.length());
            let arr = [];
            matched.forEach(it => {
                let item = {title:it.meta.title,path:it.name,isReturn:false};
                // console.log(item.path);// eslint-disable-line
                // console.log(item.title);// eslint-disable-line
                // console.log(it.path);// eslint-disable-line
                arr.push(item);
            });
            this.lists=arr;
            if(params.title && this.lists.length>1){
                sessionStorage.setItem("params", JSON.stringify(params));
                this.isReturn = true;
                if(params.orderId || params.info){
                    let info = params.orderId?params.orderId:params.info;
                    this.lists[1].title = params.title+"("+info+")";
                }else{
                    this.lists[1].title = params.title;
                }
                if(params.hide){//只显示title
                    this.lists[1].title = params.title;
                }
                this.lists[1].isReturn = true;



            }else{
                this.isReturn = false;
            }
            if(this.isReturn == false&& this.lists.length>1){

                //this.lists[1].title = params.title+"("+params.orderId+")";

                for (let i = 0; i < this.menus; i++) {
                    let it = this.menus[i];
                    if( this.lists[1].path == it.uri){
                        this.lists[1].title =  it.name;
                        break;
                    }else{
                        for (let j = 0; j < it.children; j++){
                            let item = it.children[j];
                            if( this.lists[1].path == item.uri){
                                this.lists[1].title =  it.name+" / "+item.name;
                                break;
                            }
                        }
                    }

                }

                this.menus.forEach(it => {
                    if( this.lists[1].path == it.uri){
                        this.lists[1].title =  it.name;
                        return;
                    }else{
                        it.children.forEach(item => {
                            if( this.lists[1].path == item.uri){
                                this.lists[1].title =  it.name+" / "+item.name;
                                return;
                            }
                        });
                    }
                });
            }
            // const bread = sessionStorage.getItem("bread");
            // if(bread) {
                sessionStorage.setItem("bread", JSON.stringify(this.lists));

            //}


            // let arr1 = [];
            // from.forEach(it => {
            //     let item = {title:it.meta.title,path:it.name};
            //     console.log(item.path);// eslint-disable-line
            //     console.log(item.title);// eslint-disable-line
            //     console.log(it.path);// eslint-disable-line
            //     arr1.push(item);
            // });
        }
    },

    created() {
        if(this.lists.length == 0){
            const bread = sessionStorage.getItem("bread");
            if(bread){
                this.lists = JSON.parse(bread);
                if(this.lists.length>1){
                    this.isReturn = this.lists[1].isReturn;

                }

            }
        }
        let _this = this;
        this.$axios.get("/admin/rights/model/getMenu")
        .then(response=>{
            let resp = response.data;
            if(resp.header.status == 0) {
                _this.menus = resp.data;
                _this.name = _this.getCookie("name");
                const userInfo = sessionStorage.getItem("userInfo");
                if(_this.name == null || _this.name == undefined || _this.name == ""){
                    _this.name = JSON.parse(userInfo).name;

                }

            } else {
                _this.$notify.error({
                    title: '错误',
                    message: "获取功能列表失败，请重新登录"
                });
            }
        });

        const userInfo = sessionStorage.getItem("userInfo");
        if(userInfo) {
            this.$store.commit("setUserInfo", JSON.parse(userInfo));
        }
        this.getCompanies();
    },
}
</script>
<style>
    .workspace {
        display: flex;
        flex-direction: row;
        height: 100%;
        background: #f0f2f5;
    }
    .menu {
        z-index: 10;
        width: 200px;
        height: 100%;
        overflow-x: hidden;
        background-color:#001529;
        box-shadow: 2px 0 6px rgba(0,21,41,.35);
    }
    .el-menu {
        z-index: 10;
        width: 200px;
        box-shadow: 2px 0 6px rgba(0,21,41,.35);
    }
    .el-header {
        background-color: #fff;
        z-index: 2;
    }
    .toggle {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        width: 60px;
        height: 60px;
        cursor: pointer;
        float: left;
    }
    .ops {
        float: right;
        display: flex;
        justify-content: right;
        align-items: center;
        height: 60px;
        padding-right: 20px;
    }
    .bread {
        float: left;
        display: flex;
        justify-content: right;
        align-items: center;
        height: 60px;
    }
    .el-header {
        padding: 0 !important;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 200px;
        box-shadow: 2px 0 6px rgba(0,21,41,.35);
    }
    .el-main {
        padding: 0 !important;
    }
    .content {
        padding: 20px;
    }
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        min-width: 200px;
    }

</style>
